var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { class: ["goods-list", _vm.isCourseProduct ? "course-list" : ""] },
    _vm._l(_vm.goodsList, function (item, i) {
      return _c(
        "li",
        {
          directives: [
            {
              name: "track",
              rawName: "v-track",
              value: _vm.viewTrackData
                ? {
                    act: "view",
                    id: _vm.viewTrackData.trackId,
                    data: {
                      aId: _vm.viewTrackData.algorithmId + "" || "0",
                      bId: _vm.viewTrackData.bId
                        ? _vm.viewTrackData.bId + ""
                        : "",
                      spuIds: [item.id + ""],
                    },
                  }
                : "",
              expression:
                "\n      viewTrackData\n        ? {\n            act: 'view',\n            id: viewTrackData.trackId,\n            data: {\n              aId: viewTrackData.algorithmId + '' || '0',\n              bId: viewTrackData.bId ? viewTrackData.bId + '' : '',\n              spuIds: [\n                item.id + ''\n              ]\n            },\n          }\n        : ''\n    ",
            },
          ],
          key: item.skuId,
          class: [
            "goods-item border-radius-8",
            item.skuId === -99 ? "goods-item-hidden" : "",
          ],
          on: {
            click: function ($event) {
              return _vm.clickGoodsItem(i, item.id)
            },
          },
        },
        [
          _c("div", { staticClass: "item-wrap" }, [
            _c(
              "div",
              { staticClass: "img-wrap" },
              [
                _c("img", {
                  staticClass: "rapidAfterSales-image",
                  attrs: { src: item.rapidAfterSalesImage },
                }),
                _vm._v(" "),
                _c("isSoldout", {
                  attrs: {
                    width: _vm.imgStyle.width,
                    height: _vm.imgStyle.height,
                    src: item.imgUrl,
                    isSold: item.totalInventory == 0,
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "labels" },
                  _vm._l(item.commonLabel, function (l, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "item-common-label",
                        style: `background-color:${l.labelColor}`,
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(l.title) + "\n          "
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                item.buyerLabel
                  ? _c("div", { staticClass: "buyer-label" }, [
                      _vm._v(
                        "\n          " + _vm._s(item.buyerLabel) + "\n        "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "item-describe padding-lr-10" }, [
              _c("div", { staticClass: "masterName" }, [
                item.countryImage && !_vm.isProductDetailCommend
                  ? _c("span", [
                      _c("img", {
                        staticClass: "country-image-label",
                        attrs: { src: item.countryImage },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                item.hasVideo == 1
                  ? _c("span", [
                      _c("img", {
                        staticClass: "country-image-label",
                        attrs: {
                          src: require("../../image/buyer/iconPlay.png"),
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v("\n          " + _vm._s(item.masterName) + "\n        "),
              ]),
              _vm._v(" "),
              _vm.isProductTemplatePreview
                ? _c("div", { staticClass: "product-count" }, [
                    _vm._v(
                      "\n          数量 * " + _vm._s(item.count) + "\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isHidePrice
                ? _c(
                    "div",
                    { staticClass: "priceList" },
                    [
                      _c("price", {
                        staticClass: "price origin-price",
                        style: { marginRight: "2px" },
                        attrs: {
                          originPrice: item.price,
                          intSize: "15",
                          fracSize: "10",
                        },
                      }),
                      _vm._v(" "),
                      _c("price", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !!item.groupPrice,
                            expression: "!!item.groupPrice",
                          },
                        ],
                        staticClass: "price",
                        attrs: {
                          originPrice: item.groupPrice,
                          intSize: "13",
                          fracSize: "13",
                        },
                      }),
                      _vm._v(" "),
                      _c("price", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              (!item.groupPrice || item.groupPrice == 0) &&
                              item.marketPrice > 0 &&
                              item.marketPrice > item.price,
                            expression:
                              "\n              (!item.groupPrice || item.groupPrice == 0) &&\n              item.marketPrice > 0 &&\n              item.marketPrice > item.price\n            ",
                          },
                        ],
                        staticClass: "marketPrice",
                        attrs: {
                          originPrice: item.marketPrice,
                          intSize: "11",
                          fracSize: "11",
                          color: "rgb(189, 192, 197)",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: {
                            display: "inline-block",
                            marginLeft: "-3px",
                          },
                        },
                        [
                          _c("img", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !!item.groupPrice,
                                expression: "!!item.groupPrice",
                              },
                            ],
                            staticClass: "pintuan_img",
                            attrs: {
                              src: require("../../image/global/two_people_pintuan.png"),
                              alt: "2人拼团图片",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isNeedCart
                        ? _c(
                            "div",
                            {
                              staticClass: "cart-btn",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.addToCard(i)
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../image/cart/goodslist-cart.png"),
                                  alt: "",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isCourseProduct && item.courseProductAttrText
                ? _c("div", { staticClass: "course-attr" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(item.courseProductAttrText) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }